export default __webpack_public_path__ + "static/media/me.becd9ac1.jpg";